import {crudBuilder} from "./api/crudBuilder";

const routes = {
    'cloudflare': crudBuilder({
        pattern: 'profiles/type/cloudflare/profile'
    }),
    'cloudflare.batch-create': crudBuilder({
        pattern: 'profiles/type/cloudflare/profile/batch'
    }),
    'cloudflare.profile-list': crudBuilder({
        pattern: 'profiles/type/cloudflare/profile/list'
    }),
    'cloudflare.group': crudBuilder({
        pattern: 'profiles/type/cloudflare/group'
    }),
    'cloudflare.stat.category': crudBuilder({
        pattern: 'dashboard/cloudflare',
        hasId: false
    }),
    'registrar': crudBuilder({
        pattern: 'profiles/type/registrar/profile'
    }),
    'reverseProxy': crudBuilder({
        pattern: 'profiles/type/reverse-proxy/profile'
    }),
    'proxies': crudBuilder({
        pattern: 'proxy'
    }),
    'proxies.info': crudBuilder({
        pattern: 'proxy/info'
    }),
    'server': crudBuilder({
        pattern: 'profiles/type/server/profile'
    }),
    'sites.category': crudBuilder({
        pattern: 'sites/category'
    }),
    'sites.category.setting': crudBuilder({
        pattern: 'sites/category/:categoryId/setting'
    }),
    'sites.sites': crudBuilder({
        pattern: 'sites/category/:categoryId/site'
    }),
    'sites.site.history': crudBuilder({
        pattern: 'sites/site/:siteId/transfer-history'
    }),
    'sites.site.history.backward': crudBuilder({
        pattern: 'sites/site/:siteId/history/:domainId/backward'
    }),
    'sites.site.preset-preload': crudBuilder({
        pattern: 'sites/site/:siteId/preset-preload'
    }),
    'sites.site.preset-upload': crudBuilder({
        pattern: 'sites/site/:siteId/preset-upload'
    }),
    'sites.site.rkn-status': crudBuilder({
        pattern: 'sites/site/:siteId/rkn-status'
    }),
    'sites.site.domain-info': crudBuilder({
        pattern: 'sites/site/:siteId/domain-info'
    }),
    'domain.domain-info': crudBuilder({
        pattern: 'dashboard/info/:domain'
    }),
    'sites.cloudflare.redirect-rule': crudBuilder({
        pattern: 'sites/domain/:domainId/redirect/rule'
    }),
    'sites.cloudflare.dns-record': crudBuilder({
        pattern: 'sites/domain/:domainId/dns/record'
    }),
    'site.domains': crudBuilder({
        pattern: 'sites/domain-list',
        hasId: false
    }),
    'sites.site.amp': crudBuilder({
        pattern: 'sites/category/:categoryId/amp-list',
        hasId: false
    }),
    'sites.test': crudBuilder({
        pattern: 'sites/category/:categoryId/test',
        hasId: false
    }),
    'sites.repeat-transfer': crudBuilder({
        pattern: 'sites/category/:categoryId/repeat-transfer',
        hasId: false
    }),
    'sites.backup-domain': crudBuilder({
        pattern: 'sites/category/:categoryId/backup-domain'
    }),
    'sites.site.glue-domain': crudBuilder({
        pattern: 'sites/site/:siteId/glue-domain'
    }),
    'sites.manual-transfer': crudBuilder({
        pattern: 'sites/site/:siteId/manual-transfer'
    }),
    'sites.deploy': crudBuilder({
        pattern: 'sites/category/:categoryId/deploy-site'
    }),
    'sites.waf-group': crudBuilder({
        pattern: 'sites/site/:siteId/waf-group',
    }),
    'stat.category.position': crudBuilder({
        pattern: 'stat/category/:categoryId/position'
    }),
    'stat.domain.position': crudBuilder({
        pattern: 'stat/domain/:domain/position'
    }),
    'stat.info': crudBuilder({
        pattern: 'dashboard/stat/info'
    }),
    'stat.query.param.info': crudBuilder({
        pattern: 'stat/info'
    }),
    'stat.launch': crudBuilder({
        pattern: 'dashboard/stat/launch'
    }),
    'stat.category.keyword': crudBuilder({
        pattern: 'stat/category/:categoryId/keyword'
    }),
    'user.list': crudBuilder({
        pattern: 'user/users'
    }),
    'user.maps': crudBuilder({
        pattern: 'user/maps',
        hasId: false
    }),
    'settings': crudBuilder({
        pattern: 'settings',
        hasId: false
    }),
    'randomize-domain': crudBuilder({
        pattern: 'tools/randomize-domain',
        hasId: false
    }),
    'tools.deployment.inventory': crudBuilder({
        pattern: 'tools/deployment/inventory'
    }),
    'tools.deployment.start': crudBuilder({
        pattern: 'tools/deployment/start',
        hasId: false
    }),
    'tools.deployment.status': crudBuilder({
        pattern: 'deployment/status/:taskId',
        hasId: false
    }),
    'preset': crudBuilder({
        pattern: 'preset/preset'
    }),
    'preset.page': crudBuilder({
        pattern: 'preset/preset/:presetId/page'
    }),
    'preset.page.clone': crudBuilder({
        pattern: 'preset/preset/:presetId/page/:pageId/clone',
        hasId: false
    }),
    'preset.asset': crudBuilder({
        pattern: 'preset/preset/:presetId/asset'
    }),
    'preset.clone': crudBuilder({
        pattern: 'preset/preset/:presetId/clone',
        hasId: false
    }),
    'preset.inherit': crudBuilder({
        pattern: 'preset/preset/:presetId/inherit',
        hasId: false
    }),
    'preset.asset.download': crudBuilder({
        pattern: 'preset/download/asset/:assetId',
        hasId: false
    }),
    'preset.asset.upload': crudBuilder({
        pattern: 'preset/preset/:presetId/upload-asset'
    }),
    'preset.page.template': crudBuilder({
        pattern: 'preset/page/:pageId/template'
    }),
    'preset.page.preview': crudBuilder({
        pattern: 'preset/page/:pageId/preview',
        hasId: false
    }),
    'preset.page.field': crudBuilder({
        pattern: 'preset/page/:pageId/field'
    }),
    'cloudflare.waf.group': crudBuilder({
        pattern: 'waf/group'
    }),
    'cloudflare.waf.rule': crudBuilder({
        pattern: 'waf/group/:groupId/rule'
    }),
    'cloudflare.waf.rule.change-priority': crudBuilder({
        pattern: 'waf/change-priority/:ruleId',
        hasId: false
    }),
    'domain.dns-update': crudBuilder({
        pattern: 'domain/dns-update',
        hasId: false
    }),
    'domain.npm-migrate': crudBuilder({
        pattern: 'domain/npm-migrate',
        hasId: false
    }),
    'domain.check-rkn-status': crudBuilder({
        pattern: 'domain/check-rkn-status',
        hasId: false
    }),
    'boilerplate.upload': crudBuilder({
        pattern: 'boilerplate/upload',
        hasId: false
    }),
    'boilerplate': crudBuilder({
        pattern: 'boilerplate'
    }),
    'user-settings': crudBuilder({
        pattern: 'user/settings',
        hasId: false
    }),
    'user-api': crudBuilder({
        pattern: 'user/api'
    }),
    'change-password': crudBuilder({
        pattern: 'change-password',
        hasId: false
    }),
    'notification.telegram': crudBuilder({
        pattern: 'notification'
    }),
    'dashboard.expires-domains': crudBuilder({
        pattern: 'dashboard/expires-domains',
        hasId: false
    }),
    'dashboard.blocked-domains': crudBuilder({
        pattern: 'dashboard/blocked-domains',
        hasId: false
    }),
    'dashboard.pingcheck-domains': crudBuilder({
        pattern: 'dashboard/pingcheck-domains',
        hasId: false
    }),
    'dashboard.launch-check': crudBuilder({
        pattern: 'dashboard/launch-check',
        hasId: false
    })
}

export default routes
